<div class="flex flex-col h-screen">

  <div class="px-6 pt-4 pb-2">
    <div class="flex justify-between items-center">
      <div>
        <h1 class="text-2xl font-bold text-gray-800">Grupos de Produtos</h1>
      </div>
      <div class="flex gap-2">
        <!-- <button (click)="goBack()" class="bg-orange-500 hover:bg-orange-600 cursor-pointer text-white px-4 py-2 rounded">
            Voltar
        </button> -->
        <button (click)="createGroup()" class="bg-orange-500 hover:bg-orange-600 cursor-pointer text-white px-4 py-2 rounded">
            Novo Grupo
        </button>
      </div>
     
      
    </div>
  </div>

  <div class="px-6 py-4 bg-white shadow shrink-0 z-10">
    <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
      <input type="text" [(ngModel)]="searchTerm" placeholder="Buscar por descrição ou código..." class="border border-gray-300 rounded px-3 py-2 text-sm" />
      <div class="text-sm text-gray-600 flex items-center">
        {{ totalRecords }} grupo(s) encontrado(s)
      </div>
    </div>
  </div>

  <div class="flex-1 overflow-y-auto px-6 py-4 bg-gray-50 md:mb-32 ">
    <div class="bg-white shadow rounded overflow-x-auto">
      <p-table 
        [value]="groups" 
        [paginator]="false"
        [loading]="loading"
        styleClass="p-datatable-sm"
        [rowHover]="true"
        [stripedRows]="true"
        stripedRowsClass="bg-orange-50"
        [showCurrentPageReport]="false"
        responsiveLayout="scroll"
        class="min-w-full text-sm">
        <ng-template pTemplate="header">
          <tr class="bg-gray-100">
            <th class="text-left px-6 py-3">Código </th>
            <th class="text-left px-6 py-3">Descrição</th>
            <th class="text-left px-6 py-3">Ativo</th>
            <th class="text-left px-6 py-3">Ações</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-group let-i="rowIndex">
          <tr [ngClass]="i % 2 === 0 ? 'bg-white' : 'bg-orange-50'">
            <td class="px-6 py-2 font-mono">{{ group.id }}</td>
            <td class="px-6 py-2 font-semibold text-gray-900">{{ group.description }}</td>
            <td class="px-6 py-2">{{group.active  ? 'Sim' : 'Não'}}</td>
            <td class="px-6 py-2">
              <div class="flex space-x-2">
                <p-button
                  pTooltip="Ver Receitas"
                  icon="pi pi-pencil"
                  text
                  severity="secondary"
                  (click)="edit(group)">
                </p-button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="6" class="text-center py-8 text-gray-500">
              Nenhum grupo encontrado
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
    <div class="flex justify-center py-4">
      <p-paginator
        [first]="first"
        [rows]="rows"
        [totalRecords]="totalRecords"
        (onPageChange)="onPageChange($event)"
        [showCurrentPageReport]="true"
        [showPageLinks]="true"
        [showFirstLastIcon]="true"
        styleClass="custom-paginator">
      </p-paginator>
    </div>
  </div>
</div>

<app-modal
  [header]="'Novo Grupo'"
  [(visible)]="formVisible">
    <ng-container *ngIf="formVisible">
      <app-create-group [id]="groupId" (modalClosed)="closeModal()" (formSubmitted)="onFormSubmit()"></app-create-group>
    </ng-container>
</app-modal>